import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Grid, Accordion, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import SpecialTable from './specialTable';
import PartInfo from './partInfo';
import SuggestionsTable from './suggestionsTable';
import HeadSection from './headSection';
import SOQModal from './soqModal';
import OnOrderModal from './onOrderModal';
import BackOrderModal from './backOrderModal';
import PartCheckModal from './partCheckModal';
import OrdersTotal from './suggestionsTable/totals';
import './stockOrder.scss';

class StockOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {'activeIndex': 0};
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.ProviderStockOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.restoreProviderSuggestedOrders();
  }

  componentWillUnmount() {
    this.props.restoreProviderSuggestedOrders();
  }

  handleClick(e, titleProps) {
    const {index} = titleProps;
    const {activeIndex} = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({'activeIndex': newIndex});
  }

  handleSubmit() {
    const {suggestedOrders, provider, loading} = this.props;

    if (loading) {
      return;
    }

    if (!suggestedOrders.length) {
      this.props.addMessageBoxWarning('No se puede generar un archivo sin pedidos');
      return;
    }

    const elementsToDelete = suggestedOrders.filter((element) => element.deleted);
    const elementsToProcess = suggestedOrders.filter((element) => !element.deleted);
    const orderInfo = {
      provider,
      'orderCode': suggestedOrders[0].orderCode,
      'orders': elementsToProcess,
    };

    if (elementsToDelete.length) {
      const sanitizedOrdersToDelete = elementsToDelete.map((order) => {
        return {...order, 'partCode': order.oldCode || order.partCode};
      });
      this.props.deleteProviderStockOrderPart(orderInfo, sanitizedOrdersToDelete);
      return;
    }

    this.props.processProviderStockOrder(orderInfo);
  }

  render() {
    const {activeIndex} = this.state;

    return (
      <Form className='provider-stock-orders' onSubmit={this.handleSubmit}>
        <SOQModal />
        <BackOrderModal />
        <OnOrderModal />
        <HeadSection />
        <PartCheckModal />
        <Accordion
          styled
          fluid
          className='suggested-order-section'
        >
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={this.handleClick}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width='7'>
                  <h3>Pedido Sugerido</h3>
                </Grid.Column>
                <Grid.Column textAlign='right' width='8'>
                  <OrdersTotal />
                </Grid.Column>
                <Grid.Column width='1' textAlign='right'>
                  <Icon name='dropdown' />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
            <SuggestionsTable />
          </Accordion.Content>
        </Accordion>
        <PartInfo />
        <SpecialTable />
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingSuggestions, generating} = state.providerStockOrders;

  return {
    'permissions': state.session.permissions,
    'loading': loadingSuggestions || generating,
    'provider': state.providerStockOrders.provider,
    'suggestedOrders': state.providerStockOrders.suggestedOrders,
  };
};

const {
  addMessageBoxWarning,
  restoreProviderSuggestedOrders,
  deleteProviderStockOrderPart,
  processProviderStockOrder,
  navigateTo,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  addMessageBoxWarning,
  restoreProviderSuggestedOrders,
  deleteProviderStockOrderPart,
  processProviderStockOrder,
  navigateTo,
})(StockOrder));
